export default {
  'offer-no': "Número de oferta",
  'offer-date': "Fecha de la oferta",
  'account': "Cliente",
  'notes': "Notas",
  'validity-days': "Período de validez de la oferta",
  'payment-terms': "Términos de pago",
  "total-price": "Precio total",
  "total-net": "Total Neto",
  'warehouse': "Almacén",
  "material": "Material",
  "create-offer": "Crear oferta",
  "change-offer-currency": "Cambiar moneda de la oferta",
  "discount-total": "Descuento total",
  "price-offer-delete": "Eliminar oferta de precio",
  "are-you-sure-of-delete-price-offer": "¿Estás seguro de que deseas eliminar la oferta?",
  "price-offer-update": "Oferta actualizada con éxito",
  "draft": "Borrador",
  "sent": "Enviado",
  "approved": "Aprobado",
  "rejected": "Rechazado"

}
